import {
   SIGN_IN_USER,
   VERIFY_AUTH_USER,
   LOGOUT_USER,
   GET_LIST_USERS,
   CHANGE_INPUT_VALUE_USER,
   SAVE_INFO_USER,
   GET_INFO_USER,
   DELETE_INFO_USER,
   USER_DEFAULT_DATA,
   CHANGE_INPUT_TYPE,
   CHANGE_VALUE_PASSWORD,
   LIST_PERMITS_USER,
   CHANGE_STATUS_PERMIT
} from '../constants/user';

export const user = ( state = {}, action ) => {
   switch ( action.type ) { 

      case SIGN_IN_USER : {
         return action.payload;
      }
      
      case VERIFY_AUTH_USER : {
         return action.payload;
      }

      case LOGOUT_USER : {
         return action.payload;
      }

      case GET_LIST_USERS : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_USER : {
         return action.payload;
      }

      case SAVE_INFO_USER : {
         return action.payload;
      }

      case GET_INFO_USER : {
         return action.payload;
      }

      case DELETE_INFO_USER : {
         return action.payload;
      }

      case USER_DEFAULT_DATA : {
         return action.payload;
      }

      case CHANGE_INPUT_TYPE : {
         return action.payload;
      }

      case CHANGE_VALUE_PASSWORD : {
         return action.payload;
      }

      case LIST_PERMITS_USER : {
         return action.payload;
      }

      case CHANGE_STATUS_PERMIT : {
         return action.payload;
      }
 
     default :
     return state;
   }
}


